
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class BreadCrumb extends Vue {
  data () {
    return {
    }
  }

  get breadCrumbs () {
    if (typeof this.$route.meta.breadCrumb === 'function') {
      return this.$route.meta.breadCrumb.call(this, this.$route)
    }
    return this.$route.meta.breadCrumb
  }
}
